module.exports = __webpack_public_path__ + "static/drive-america__hero.6fd58bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/drive-america__hero.jpg
// module id = 492
// module chunks = 104248490918402